import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user-preference-store'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
  },
  plugins: [createPersistedState()],
  strict: debug
})
